import type { Config } from '../config/types';
import type { AbstractLogger } from '../logger/components/AbstractLogger';
import { createLogger } from '../logger/utils/createLogger';

export class App {
  private readonly _config: Config;

  private readonly _logger: AbstractLogger;

  public constructor(config: Config) {
    this._config = { ...config };

    this._logger = createLogger(config);
  }

  public get config(): Config {
    return this._config;
  }

  public get logger() {
    return this._logger;
  }
}
